export function requestTextBeeSetup({ signal } = {}) {
  if (signal?.aborted) return Promise.resolve(null);
  return new Promise(resolve => {
    const previous = document.activeElement;
    const dialog = document.createElement("dialog");
    dialog.className = "sms-setup-dialog";
    dialog.setAttribute("aria-label", "Connect SMS gateway");
    const form = document.createElement("form");
    form.autocomplete = "off";
    const title = document.createElement("h2");
    title.textContent = "Connect SMS gateway";
    form.append(title);
    const fields = [
      ["deviceId", "TextBee device ID", "text"],
      ["webhookSubscriptionId", "Webhook subscription ID", "text"],
      ["receivingNumber", "Gateway phone number", "tel"],
      ["allowedSender", "Approved test sender", "tel"]
    ];
    const inputs = {};
    for (const [name, labelText, type] of fields) {
      const label = document.createElement("label");
      label.textContent = labelText;
      const input = document.createElement("input");
      input.name = name;
      input.type = type;
      input.required = true;
      input.maxLength = type === "tel" ? 16 : 220;
      input.pattern = type === "tel" ? "\\+[1-9][0-9]{7,14}" : "[A-Za-z0-9._:\\-]{1,220}";
      if (type === "tel") { input.placeholder = "+12025550123"; input.inputMode = "tel"; }
      input.spellcheck = false;
      inputs[name] = input;
      label.append(input);
      form.append(label);
    }
    const consent = document.createElement("label");
    consent.className = "sms-setup-consent";
    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.required = true;
    checkbox.name = "phoneFilterConfirmed";
    const consentText = document.createElement("span");
    consentText.textContent = "I own this gateway and approve forwarding this test sender's SMS to the configured TextBee server and EPIC. The phone's allow list contains only this sender.";
    consent.append(checkbox, consentText);
    const mode = document.createElement("p");
    mode.textContent = "Receive only. Replies and AI sending are disabled.";
    const footer = document.createElement("footer");
    const cancel = document.createElement("button");
    cancel.type = "button";
    cancel.textContent = "Cancel";
    cancel.addEventListener("click", () => dialog.close());
    const submit = document.createElement("button");
    submit.type = "submit";
    submit.className = "primary-action";
    submit.textContent = "Connect gateway";
    footer.append(cancel, submit);
    form.append(consent, mode, footer);
    dialog.append(form);
    let result = null;
    const abort = () => dialog.close();
    form.addEventListener("submit", event => {
      event.preventDefault();
      if (!form.reportValidity() || signal?.aborted) return;
      result = { schema: "textbee_gateway.v1", phoneFilterConfirmed: true };
      for (const [name, input] of Object.entries(inputs)) result[name] = input.value.trim();
      dialog.close();
    });
    dialog.addEventListener("close", () => {
      signal?.removeEventListener("abort", abort);
      form.reset();
      dialog.remove();
      if (previous?.isConnected) previous.focus();
      resolve(signal?.aborted ? null : result);
    }, { once: true });
    signal?.addEventListener("abort", abort, { once: true });
    document.body.append(dialog);
    dialog.showModal();
    inputs.deviceId.focus();
  });
}
